<template>
  <v-row justify="center">
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-card-title>{{ titulo }}</v-card-title>
        <v-card-text style="color: black">
          <p>{{ mensagemInicial }} <b>{{ mensagemMeio }}</b> {{ mensagemFinal }}</p>
          <v-textarea
              v-model="justificativa"
              name="justificativa"
              :label="labelJustificativa"
              :placeholder="placeholder"
              v-validate="{required: isObrigatorio, max: tamanhoMaximo}"
              :error-messages="errors.collect('justificativa')"
              counter
              filled
              auto-grow
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="cancelar" :color="corCancelar">{{ textCancelar }}</v-btn>
          <v-btn @click="confirmar" text :color="corConfirmar">{{ textConfirmar }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name: 'Confirm-mensagem-modal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        mensagemInicial: String,
        mensagemMeio: String,
        mensagemFinal: String,
        persistencia: {
            type: Boolean,
            default: true
        },
        titulo: {
            type: String,
            default: 'Atenção!'
        },
        textCancelar: {
            type: String,
            default: 'Cancelar'
        },
        textConfirmar: {
            type: String,
            default: 'Excluir'
        },
        corCancelar: {
            type: String,
            default: 'black'
        },
        corConfirmar: {
            type: String,
            default: 'red'
        },
        maxWidth: {
            type: Number,
            default: 400
        },
        isObrigatorio: {
            type: Boolean,
            default: true
        },
        tamanhoMaximo: {
            type: Number,
            default: 100
        },
        placeholder: {
            type: String,
            default: 'Informe a justificativa...'
        },
        labelJustificativa: {
            type: String,
            default: 'Justificativa:'
        }
    },
    data() {
        return {
            justificativa: null,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('modalAcaoCancelar')
        },
        confirmar() {
            this.model = false
            this.$emit('modalAcaoConfirmar', this.justificativa)
        }
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

</style>